import * as React from "react";

import { agentAppIconSrc } from "@replohq/lattice/icons/agentAppIconSrc";

export const adminCommandIcon = {
  type: "custom" as const,
  content: (
    <img
      src={agentAppIconSrc.admin}
      alt=""
      className="h-[16px] w-[16px] rounded-[3px] object-cover"
    />
  ),
};
